import gql from 'graphql-tag';

export const CAMPAIGN_SETTINGS_PUBLISHERS_FRAGMENT = gql`
  fragment PublisherFragment on Publisher {
    __typename
    id
    name
    temporaryHandoff
    pageLockedArticlesEnabled

    accountManager {
      id
      email
    }

    temporaryAccountManager {
      id
      email
    }

    accountSupervisor {
      id
      email
    }

    billingCenter {
      enabled
      instances
    }

    facebookAccounts {
      accountId
      timezone
      name
      id
    }

    publisherFacebookAccounts {
      priority
      facebookAccount {
        id
        name
        accountId
        businessId
        businessIdType
      }
    }
  }
`;
